import React from 'react';

interface LogoProps {
  className?: string;
  onClick?: () => void;
  size?: 'default' | 'lg' | 'xl';
}

const sizeConfig = {
  default: { icon: 32, gap: 'gap-2', text: 'text-xl' },
  lg: { icon: 48, gap: 'gap-3', text: 'text-3xl' },
  xl: { icon: 72, gap: 'gap-4', text: 'text-5xl' },
};

const Logo: React.FC<LogoProps> = ({ className = '', onClick, size = 'default' }) => {
  const { icon, gap, text } = sizeConfig[size];

  return (
    <div
      onClick={onClick}
      className={`flex cursor-pointer items-center ${gap} transition-all hover:-translate-y-px ${className}`}
    >
      {/* Icon: Overlapping layers */}
      <svg width={icon} height={icon} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="10" width="18" height="18" rx="4" fill="#6366f1" opacity="0.9"/>
        <rect x="8" y="6" width="18" height="18" rx="4" fill="#8b5cf6" opacity="0.85"/>
        <rect x="14" y="12" width="18" height="18" rx="4" fill="#d946ef" opacity="0.8"/>
        <path d="M28 14 L34 8 L36 10 L30 16 Z" fill="#f59e0b"/>
        <circle cx="34.5" cy="7.5" r="1.5" fill="#f59e0b"/>
      </svg>

      {/* Typography */}
      <span className={`${text} font-bold tracking-tight`}>
        <span className="bg-gradient-to-r from-indigo-500 via-purple-500 to-fuchsia-500 bg-clip-text text-transparent">
          Image
        </span>
        <span className="bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-500 bg-clip-text text-transparent font-light">
          Editor
        </span>
      </span>
    </div>
  );
};

export default Logo;
